import { InfoCircleOutlined } from '@ant-design/icons';
import { Input, Typography } from 'antd';

import { COMMENT_REPLY_TEXT_MAX_LENGTH } from '@app/components/Modals/BotDetailsModal/constants/commentReply';
import { getCommentReplyTextError } from '@app/components/Modals/BotDetailsModal/utils/commentReply';
import { INSTAGRAM } from '@app/constants/socialIntegrationsTypes';
import { FormItem } from '@app/pages/TasksList/components';

import type { FormRule } from 'antd';
import type { FC } from 'react';

import './CommentReplyField.scss';

const { TextArea } = Input;
const { Text } = Typography;

interface CommentReplyFieldProps {
  socialType: string | undefined;
}

const COMMENT_REPLY_HINT =
  'Робот опубликует этот текст под комментарием клиента в Instagram после ответа в Direct. В начало робот поставит @имя автора. Не добавляйте ссылки: Instagram ограничивает аккаунты за однотипные ответы со ссылками.';

const COMMENT_REPLY_TEXT_RULES: FormRule[] = [
  {
    validator: (_rule, value: string | undefined) => {
      const error = getCommentReplyTextError(value);

      return error ? Promise.reject(new Error(error)) : Promise.resolve();
    },
  },
];

export const CommentReplyField: FC<CommentReplyFieldProps> = ({
  socialType,
}) => {
  if (socialType !== INSTAGRAM) {
    return (
      <Text
        type="secondary"
        className="CommentReplyField CommentReplyField--unavailable"
      >
        <InfoCircleOutlined /> Для канала Instagram доступен ответ под
        комментарием клиента — выберите этот канал, чтобы его настроить.
      </Text>
    );
  }

  return (
    <div className="CommentReplyField">
      <FormItem
        name="commentReplyText"
        label="Ответ под комментарием"
        rules={COMMENT_REPLY_TEXT_RULES}
        extra={COMMENT_REPLY_HINT}
      >
        <TextArea
          className="CommentReplyField__textarea"
          rows={3}
          maxLength={COMMENT_REPLY_TEXT_MAX_LENGTH}
          showCount
          placeholder="Например: Ответили в директ"
        />
      </FormItem>
    </div>
  );
};
